import { alpha } from '@mui/material/styles'

const GREY = {
  50: 'rgba(0,0,0,0.3)',
  100: '#f4f4f5',
  200: '#e4e4e7',
  300: '#d4d4d8',
  400: '#a1a1aa',
  500: '#71717a',
  600: '#52525b',
  700: '#3f3f46',
  800: '#27272a',
  900: '#18181b'
}

const PRIMARY = {
  lighter: '#F95C12FF',
  light: '#f95c12',
  main: '#d6500d',
  dark: '#873408',
  darker: '#873408FF',
  contrastText: '#fff'
}

const SECONDARY = {
  lighter: '#A5A5B3FF',
  light: '#a5a5b3',
  main: '#75757f',
  dark: '#2d2d31',
  darker: '#2D2D31FF',
  contrastText: '#fff'
}

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff'
}

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800]
}

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800]
}

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff'
}

const paletteLight = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500]
  },
  background: {
    paper: '#fff',
    default: GREY[100],
    neutral: GREY[200]
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
}

const paletteDark = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[300], 0.24),
  text: {
    primary: GREY[200],
    secondary: GREY[400],
    disabled: GREY[500]
  },
  background: {
    paper: '#0f0f11',
    default: '#0f0f11',
    neutral: GREY[800]
  },
  action: {
    active: GREY[300],
    hover: alpha(GREY[300], 0.08),
    selected: alpha(GREY[300], 0.16),
    disabled: alpha(GREY[300], 0.8),
    disabledBackground: alpha(GREY[300], 0.24),
    focus: alpha(GREY[300], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
}

export { paletteLight, paletteDark }
